import { callApi } from "./api";

export const fetchPageDynamicData = async () => {
    try {
        const user = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : null;

        const payload = {
            roleId: userDetails?.role_id ?? null,
            userId: userDetails?.userId ?? null,
            roleType: userDetails?.roleType ?? null,
        };

        const res = await callApi(
            "POST",
            "authenticating_pages_list_new.php",
            payload
        );

        return res?.data?.responseJson?.data || [];
    } catch (error) {
        console.error("Page Dynamic API Error:", error);
        return [];
    }
};


export const hasPageAccess = async (pageName: string): Promise<boolean> => {
    const pageDynamic = await fetchPageDynamicData();

    return pageDynamic.some(
        (page: any) =>
            page.page_name === pageName && page.status === true
    );
};
